module.exports = __webpack_public_path__ + "static/media/oval-capital-small.a2589d1a.png";